import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=389004a1&scoped=true&"
import script from "./footer.vue?vue&type=script&lang=js&"
export * from "./footer.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./footer.vue?vue&type=style&index=0&id=389004a1&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "389004a1",
  "73d2adb1"
  
)

export default component.exports